const timestamp = (value) => {
  const parsed = value ? new Date(value).getTime() : 0;
  return Number.isFinite(parsed) ? parsed : 0;
};

export const aggregateLegacyQuizResults = (results) => {
  const grouped = new Map();
  (Array.isArray(results) ? results : []).forEach((item) => {
    const quizId = item?.quiz_id || 'unknown';
    const existing = grouped.get(quizId);
    if (existing) {
      existing.attempt_count += 1;
      if (timestamp(item?.ts) > timestamp(existing.last_attempt_ts)) {
        existing.last_attempt_ts = item.ts;
      }
      return;
    }
    grouped.set(quizId, {
      quiz_id: quizId,
      quiz_name: item?.quiz_name || 'Quiz',
      attempt_count: 1,
      last_attempt_ts: item?.ts,
    });
  });
  return Array.from(grouped.values())
    .sort((left, right) => timestamp(right.last_attempt_ts) - timestamp(left.last_attempt_ts));
};

export const completedPracticeReviews = (practices) => (Array.isArray(practices) ? practices : [])
  .filter((item) => item?.status === 'completed' || item?.latest_attempt?.status === 'completed')
  .map((item) => ({
    ...item,
    review_timestamp: item?.latest_attempt?.completed_at
      || item?.completed_at
      || item?.updated_at
      || item?.assignment?.updated_at
      || item?.assignment?.created_at,
  }))
  .sort((left, right) => timestamp(right.review_timestamp) - timestamp(left.review_timestamp));

export const practiceAccuracyPercent = (item) => {
  const attempt = item?.latest_attempt || {};
  const accuracy = Number(attempt.accuracy);
  if (Number.isFinite(accuracy)) return Math.max(0, Math.min(100, Math.round(accuracy * 100)));
  const score = Number(attempt.score);
  const maxScore = Number(attempt.max_score);
  if (Number.isFinite(score) && Number.isFinite(maxScore) && maxScore > 0) {
    return Math.max(0, Math.min(100, Math.round((score / maxScore) * 100)));
  }
  return null;
};

export const practiceMeaningLabels = (item, limit = 8) => {
  const sourceItems = item?.assignment?.source?.items_snapshot;
  if (!Array.isArray(sourceItems)) return [];
  return sourceItems.slice(0, limit).map((sourceItem) => {
    const word = String(sourceItem?.word || '').trim();
    const meaning = String(
      sourceItem?.definition_cn
      || sourceItem?.chinese
      || sourceItem?.meaning
      || sourceItem?.definition_en
      || '',
    ).trim();
    return meaning ? `${word}（${meaning}）` : word;
  }).filter(Boolean);
};
